import { useTranslation } from 'react-i18next'
import HistoryTimeline from '../../../components/ui/HistoryTimeline'
import EmptyState from '../../../components/ui/EmptyState'
import LoadingSkeleton from '../../../components/ui/LoadingSkeleton'
import { useTicketRequestDetail } from '../hooks/useTicketRequestDetail'
import { ticketActivityEvents } from '../lib/ticketActivityEvents'

interface TicketHistoryPanelProps {
  ticketId: number
  /** 037: özel kalem, tam-kimlikle bulduğu kendi-dışı satırın geçmişini de görebilsin diye taşınır (backend kanıtı). */
  exactPnr?: string
  exactName?: string
}

/**
 * Talep listesi satırı genişletildiğinde satır altında gösterilen **İşlem Geçmişi** paneli (014 US2).
 * Talebin detayını `useTicketRequestDetail` ile lazy-fetch eder (liste satırı geçmiş alanlarını
 * içermez) ve Talep Detay sayfasıyla **birebir aynı** olay üreticisini (`ticketActivityEvents`) +
 * paylaşılan `ui/HistoryTimeline` bileşenini kullanır (FR-009, Reuse Mandate).
 */
export default function TicketHistoryPanel({
  ticketId,
  exactPnr,
  exactName,
}: Readonly<TicketHistoryPanelProps>) {
  const { t } = useTranslation()
  const { data, isLoading, isError } = useTicketRequestDetail(ticketId, exactPnr, exactName)

  return (
    <div className="tk-row-history">
      <h3 className="tk-row-history-title">{t('tickets.detail.history.title')}</h3>
      {isLoading && <LoadingSkeleton lines={2} />}
      {!isLoading && (isError || !data) && (
        <EmptyState icon="pi pi-exclamation-circle" title={t('tickets.actionError')} />
      )}
      {!isLoading && data && <HistoryTimeline events={ticketActivityEvents(data, t)} />}
    </div>
  )
}
